import { SettingsUsersViews } from "views/settings-users/types";

/** Settings › Users › AI agents tab. */
export const AGENTS_TAB_URL = `/settings/users?view=${encodeURIComponent(
  SettingsUsersViews.Agents
)}`;

/**
 * Where a leasing agent is edited: a draft (wizard not finished) resumes its
 * wizard at the last completed step, a finished one opens its detail page.
 */
export const getLeasingAgentRoute = (agent: {
  id: number;
  wizard_status: string | null;
  wizard_step: number | null;
}) => {
  if (agent.wizard_status !== "finished")
    return `/settings/users/add-agent/${agent.id}?step=${agent.wizard_step ?? 1}`;

  return `/settings/leasing-agents/${agent.id}`;
};
